module.exports = __webpack_public_path__ + "img/plus_btn.b5b9323a.png";